import { Heading, magma } from 'react-magma-dom';
import { DocsHeading } from "../../../../src/components/DocsHeading";
import SketchLogo from "../../../../src/images/logos/sketch-symbol.svg";
import InvisionLogo from "../../../../src/images/logos/invision_icon_pink.svg";
import AbstractLogo from "../../../../src/images/logos/abstract-logo.svg";
import * as React from 'react';
export default {
  Heading,
  magma,
  DocsHeading,
  SketchLogo,
  InvisionLogo,
  AbstractLogo,
  React
};